var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"/dzj/start.html","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":"true","webkitallowfullscreen":"true","mozallowfullscreen":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }